import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { colors } from "../../configs";

const TimeOut = () => {
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundColor: colors.main,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Box
        sx={{
          display: "flex",
          maxWidth: "50%",
          flexDirection: "column",
          justifyContent: "center",
          aliginItems: "center",
          padding: "25px",
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          gap: 3,
        }}>
        <Typography
          variant="h3"
          component="code"
          sx={{
            textAlign: "center",
          }}>
          This offer is no longer availlble!
        </Typography>
        <Typography
          variant="body1"
          component="code"
          sx={{
            textAlign: "center",
          }}>
          This offer has expired and we can no longer guarantee the price of
          this ticket. We recommend you to restart a new search.{" "}
        </Typography>
        <Button
          variant="contained"
          sx={{
            color: "#FFFFFF",
            padding: "12px",
            borderRadius: "12px",
          }}>
          Launch new search
        </Button>
      </Box>
    </Box>
  );
};

export default TimeOut;
